import { Query } from '@tanstack/react-query'
import { CustomReportArgument } from '../../../redux/context/customReports/types'

type StrippedArg = Pick<CustomReportArgument, 'id' | 'type' | 'values'>

export const stripArgs = (args?: CustomReportArgument[]): StrippedArg[] | undefined =>
  args?.map(({ id, type, values }) => ({ id, type, values }))

export interface SectionQueryParams {
  date?: string
  language?: string
  args?: CustomReportArgument[]
}

const customReportQueryKeys = {
  all: [{ scope: 'customReport' }] as const,
  lists: () => [{ ...customReportQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: string) => [{ ...customReportQueryKeys.lists()[0], companyId }] as const,
  details: () => [{ ...customReportQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (companyId?: string, id?: number) => [{ ...customReportQueryKeys.details()[0], companyId, id }] as const,
  groups: (companyId: string) => [{ ...customReportQueryKeys.lists()[0], type: 'group', companyId }] as const,
  sections: () => [{ ...customReportQueryKeys.all[0], entity: 'section' }] as const,
  section: (companyId: string, reportId: number, sectionId: number, params: SectionQueryParams) =>
    [
      {
        ...customReportQueryKeys.sections()[0],
        companyId,
        reportId,
        sectionId,
        ...params,
        args: stripArgs(params.args)
      }
    ] as const
}

export default customReportQueryKeys

type SectionQueryKey = ReturnType<typeof customReportQueryKeys.section>[0]

const isSectionQueryKey = (key: unknown): key is readonly [SectionQueryKey] => {
  if (!Array.isArray(key) || key.length === 0) return false
  const first = key[0]
  return (
    typeof first === 'object' &&
    first !== null &&
    (first as { scope?: unknown }).scope === 'customReport' &&
    (first as { entity?: unknown }).entity === 'section' &&
    typeof (first as { sectionId?: unknown }).sectionId === 'number'
  )
}

export const isSectionQuery = (query: Query, sectionId: number) =>
  isSectionQueryKey(query.queryKey) && query.queryKey[0].sectionId === sectionId
